













import { registerEvent, unregisterEvent, AxEventType } from '@aspenware-library/event-hub'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { localStorageService } from '@plugin/Common/services/cross-sell/local-storage.service'
import CrossSellAddedToCart from '@plugin/Common/components/cross-sell/CrossSellAddedToCart.vue'
import { AddToCartEventInterface } from '@plugin/Common/interfaces/cross-sell/add-to-cart-event.interface'
import { RemoveFromCartEventInterface } from '@plugin/Common/interfaces/cross-sell/remove-from-cart-event.interface'

@Component({
  components: {
    CrossSellAddedToCart,
  },
})
export default class CrossSellAddedToCartViewComponent extends Vue {
  @Prop({
    type: String,
    default: 'You might also be interested in',
  })
  public title!: string

  @Prop({
    type: String,
    default: 'No thanks',
  })
  public cancelButtonLabel!: string

  private eventTimestamp: number = 0

  private productId: number = 0

  mounted() {
    registerEvent<AddToCartEventInterface>(AxEventType.AddToCart, this.consumeAddToCartEvent)
    registerEvent<RemoveFromCartEventInterface>(AxEventType.RemoveFromCart, this.consumeRemoveFromCartEvent)
    registerEvent(AxEventType.CartIsEmpty, this.consumeCartIsEmptyEvent)
  }

  beforeDestroy() {
    unregisterEvent<AddToCartEventInterface>(AxEventType.AddToCart, this.consumeAddToCartEvent)
    unregisterEvent<RemoveFromCartEventInterface>(AxEventType.RemoveFromCart, this.consumeRemoveFromCartEvent)
    unregisterEvent(AxEventType.CartIsEmpty, this.consumeCartIsEmptyEvent)
  }

  public consumeRemoveFromCartEvent(event?: RemoveFromCartEventInterface): void {
    if (event) {
      localStorageService.removeProductViewCount(event.productId ? event.productId : -1)
    }
  }

  public consumeCartIsEmptyEvent(): void {
    localStorageService.removeAllProductViewCounts()
  }

  public consumeAddToCartEvent(event?: AddToCartEventInterface): void {
    this.eventTimestamp = new Date().getMilliseconds()
    this.productId = event?.productId ?? 0
  }
}
